module.exports = __webpack_public_path__ + "img/auto_texts_hover.dd561be6.svg";